import React from 'react'
import PropTypes from 'prop-types'
import { TimelineLite, TweenLite } from 'gsap'
import Avatar from './Avatar'
import CustomLink from './CustomLink'

class LoggedInAs extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isExpanded: false
        }
    }

    handleClick (event) {
        this.state.isExpanded ? this.doClose() : this.doOpen()
    }

    doOpen () {
        const tl = new TimelineLite()
        tl.set(this.logout, { display: 'flex', width: 'auto' })
        tl.from(this.logout, 0.2, { width: 0, ease: Power4.easeOut })
        tl.add(() => this.setState({ isExpanded: true }))
    }

    doClose () {
        const tl = new TimelineLite()
        tl.to(this.logout, 0.2, { width: 0, ease: Power4.easeOut })
        tl.set(this.logout, { display: 'none' }, '-=0.1')
        tl.add(() => this.setState({ isExpanded: false }))
    }

    handleMouseOver () {
        TweenLite.to(this.icon, 0.1, { scale: 1.1 })
    }

    handleMouseOut () {
        TweenLite.to(this.icon, 0.1, { scale: 1 })
    }

    render () {
        return (
            <div className='logged-in-as d-none d-lg-flex justify-content-end align-items-center'>
                <Avatar
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    handleClick={this.handleClick.bind(this)}
                />
                <div ref={el => this.logout = el} className='link-wrapper'>
                    <CustomLink
                        to='/logout'
                        className='ml-3 d-flex align-items-center'
                        onMouseOver={this.handleMouseOver.bind(this)}
                        onMouseOut={this.handleMouseOut.bind(this)}
                    >
                        <div>Logout</div>
                        <img ref={el => this.icon = el} src='/images/icon-logout-arrow.svg' alt='' />
                    </CustomLink>
                </div>
            </div>
        )
    }
}

LoggedInAs.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string
}

export default LoggedInAs



// WEBPACK FOOTER //
// ./resources/js/components/LoggedInAs.js